module.exports = __webpack_public_path__ + "static/media/yv_logo.f1283166.svg";